// ============================================
// OLA Cosmetics — Ultra Premium Scroll Engine
// Every section animated, parallax, 3D, morph
// ============================================
(function() {
  'use strict';

  // 1. REVEAL ON SCROLL
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('revealed');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

  // 2. TEXT COLOR REVEAL ON SCROLL
  function updateTextReveal() {
    document.querySelectorAll('.text-reveal').forEach(el => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      let progress = 1 - (rect.top - vh * 0.3) / (vh * 0.55);
      progress = Math.max(0, Math.min(1, progress));
      const gray = Math.round(220 - progress * 192);
      el.style.color = `rgb(${gray},${gray},${gray})`;
      el.querySelectorAll('.text-reveal__img').forEach(img => {
        img.style.opacity = progress;
        img.style.transform = `scale(${0.85 + progress * 0.15})`;
      });
    });
  }

  // 3. PARALLAX
  function updateParallax() {
    document.querySelectorAll('[data-parallax]').forEach(el => {
      const speed = parseFloat(el.dataset.parallax) || 0.15;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      if (rect.bottom > 0 && rect.top < vh) {
        const center = (rect.top + rect.height / 2 - vh / 2) / vh;
        el.style.transform = `translateY(${center * speed * 100}px)`;
      }
    });
  }

  // 4. SLIDE-IN FROM SIDES
  const slideObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('slid-in');
        slideObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
  document.querySelectorAll('.slide-from-left, .slide-from-right, .slide-from-bottom, .scale-in').forEach(el => slideObs.observe(el));

  // 5. STICKY HEADER
  const header = document.querySelector('.site-header');
  let lastScroll = 0;
  function updateHeader() {
    if (!header) return;
    const y = window.scrollY;
    header.classList.toggle('header--shrink', y > 100);
    if (y > 300) {
      header.classList.toggle('header--hidden', y > lastScroll && y - lastScroll > 5);
    } else {
      header.classList.remove('header--hidden');
    }
    lastScroll = y;
  }

  // 6. ANIMATED COUNTERS
  function updateCounters() {
    document.querySelectorAll('[data-count-to]').forEach(el => {
      if (el.dataset.counted) return;
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.8) {
        el.dataset.counted = 'true';
        const target = parseInt(el.dataset.countTo);
        const suffix = el.dataset.countSuffix || '';
        const dur = 2000, start = performance.now();
        function tick(now) {
          const p = Math.min((now - start) / dur, 1);
          el.textContent = Math.round((1 - Math.pow(1 - p, 3)) * target).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }
    });
  }

  // 7. SCROLL PROGRESS BAR
  const progressBar = document.createElement('div');
  progressBar.className = 'scroll-progress-bar';
  document.body.appendChild(progressBar);
  function updateProgressBar() {
    const h = document.documentElement.scrollHeight - window.innerHeight;
    progressBar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
  }

  // 8. 3D TILT on hover
  document.querySelectorAll('.tilt-3d').forEach(el => {
    el.addEventListener('mousemove', e => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = `perspective(800px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) scale(1.02)`;
    });
    el.addEventListener('mouseleave', () => {
      el.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1)';
      el.style.transform = '';
      setTimeout(() => el.style.transition = '', 500);
    });
  });

  // 9. MAGNETIC BUTTONS
  document.querySelectorAll('.btn--magnetic').forEach(btn => {
    btn.addEventListener('mousemove', e => {
      const r = btn.getBoundingClientRect();
      btn.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.2}px, ${(e.clientY - r.top - r.height / 2) * 0.2}px)`;
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transition = 'transform 0.4s cubic-bezier(0.16,1,0.3,1)';
      btn.style.transform = '';
      setTimeout(() => btn.style.transition = '', 400);
    });
  });

  // 10. SMOOTH IMAGE LOAD
  document.querySelectorAll('img:not(.no-fade)').forEach(img => {
    if (!img.classList.contains('img--fade-in')) img.classList.add('img--fade-in');
    if (img.complete && img.naturalWidth) img.classList.add('loaded');
    else img.addEventListener('load', () => img.classList.add('loaded'));
  });

  // 11. CURSOR GLOW
  if (window.matchMedia('(pointer:fine)').matches) {
    const g = document.createElement('div');
    g.className = 'cursor-glow';
    document.body.appendChild(g);
    document.addEventListener('mousemove', e => {
      g.style.left = e.clientX + 'px';
      g.style.top = e.clientY + 'px';
    }, { passive: true });
  }

  // 12. STAGGER GRID
  const staggerObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        Array.from(e.target.children).forEach((child, i) => {
          setTimeout(() => child.classList.add('revealed'), i * 120);
        });
        staggerObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.stagger-grid').forEach(el => staggerObs.observe(el));

  // 13. SCROLL INDICATORS
  document.querySelectorAll('.scroll-indicator').forEach(el => {
    el.addEventListener('click', () => {
      const next = el.closest('section, [class*="shopify-section"]')?.nextElementSibling;
      if (next) next.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // 14. HOVER ZOOM
  document.querySelectorAll('.hover-zoom').forEach(wrap => {
    const img = wrap.querySelector('img');
    if (!img) return;
    wrap.addEventListener('mousemove', e => {
      const rect = wrap.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - rect.left) / rect.width) * 100}% ${((e.clientY - rect.top) / rect.height) * 100}%`;
    });
  });

  // 15. QUICK-ADD FEEDBACK
  document.addEventListener('click', e => {
    const btn = e.target.closest('.fp-card__quick-add');
    if (!btn) return;
    const orig = btn.textContent;
    btn.textContent = '✓ נוסף';
    btn.style.background = '#2d7a3a';
    setTimeout(() => { btn.textContent = orig; btn.style.background = ''; }, 1600);
  });

  // 16. SPLIT SECTION PARALLAX
  function updateSplitParallax() {
    document.querySelectorAll('.split-section__media img').forEach(img => {
      const section = img.closest('.split-section');
      if (!section) return;
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      if (rect.bottom > 0 && rect.top < vh) {
        const progress = (vh - rect.top) / (vh + rect.height);
        img.style.transform = `scale(1.1) translateY(${(progress - 0.5) * -40}px)`;
      }
    });
  }

  // 17. CATEGORY TEXT LINKS — color reveal
  function updateCategoryLinks() {
    document.querySelectorAll('.category-text-link').forEach(el => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      if (rect.top < vh * 0.8 && rect.bottom > 0) {
        const progress = Math.max(0, Math.min(1, 1 - (rect.top / (vh * 0.8))));
        const gray = Math.round(200 - progress * 172);
        el.style.color = `rgb(${gray},${gray},${gray})`;
      }
    });
  }

  // 18. SECTION ENTRANCE: auto-add animation classes to all sections
  document.querySelectorAll('[class*="shopify-section"]').forEach((sec, i) => {
    const inner = sec.firstElementChild;
    if (inner && !inner.classList.contains('reveal') && !inner.classList.contains('hero-banner__media')) {
      // Don't add to hero or already-animated sections
      if (!inner.querySelector('.reveal') && !inner.classList.contains('marquee-text')) {
        // Already handled by individual sections
      }
    }
  });

  // MASTER SCROLL HANDLER
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateTextReveal();
        updateParallax();
        updateHeader();
        updateCounters();
        updateProgressBar();
        updateSplitParallax();
        updateCategoryLinks();
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

})();
